import React, { PropsWithChildren, useEffect } from "react";

const Container: React.FC<PropsWithChildren> = ({ children }) => {
  return <>{children} </>;
};

export const DisabledContainer: React.FC<
  PropsWithChildren & {
    show: boolean;
    height?: string;
  }
> = ({ children, show, height }) => {
  const childrenRef = React.useRef<HTMLDivElement>(null);
  const [childrenHeight, setChildrenHeight] = React.useState<string>(
    height ?? "100%",
  );
  useEffect(() => {
    if (childrenRef.current && height) {
      setChildrenHeight(height);
    } else if (childrenRef.current) {
      setChildrenHeight(`${childrenRef.current.offsetHeight}px`);
    }
  }, [children, height]);

  // Keep a single stable wrapper regardless of `show`: swapping between a
  // wrapped and bare children tree remounts the whole subtree, which re-fires
  // refetchOnMount queries and wipes child state (e.g. open dialogs) on every
  // isLoading toggle.
  return (
    <div ref={childrenRef} style={{ position: "relative" }}>
      {show && (
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: childrenHeight,
            zIndex: 99,
            // A light veil rather than the previous surface fill at 0.7 opacity,
            // which read as an unintended dark panel behind the Map Attribute
            // Value Source row. It must still dim: in ImportUser and
            // AttributeDialog the wrapped controls aren't individually disabled,
            // so this overlay is the only signal that the section is inert —
            // with no fill at all it silently swallows clicks on controls that
            // still look interactive.
            backgroundColor: "var(--tlx-overlay-disabled)",
            cursor: "not-allowed",
            borderRadius: "var(--tlx-radius-md)",
          }}
        />
      )}
      {children}
    </div>
  );
};

export default Container;
